import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/Table';
import * as _ from 'lodash';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import Tooltip from '../../components/Tooltip';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import {
  readCompanyPosition,
  updateCompanyPosition,
  deleteCompanyPosition,
  listCompanyPositions,
} from '../../redux/actions/table/company_positions';
import { __, validateForm } from '../../core/utils';
import { setPlusActions } from '../../redux/actions/general/plus';
import EditCompanyPositionsForm from '../../forms/company_positions/EditCompanyPositionsForm';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import styles from '../../styles/views/company_positions/CompanyPositions.scss';
import { get } from 'lodash';
import autobind from 'autobind-decorator';

const mapStateToProps = (state) => {
  return {
    table: state.table['company_positions'],
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.company_positions/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
class CompanyPositions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team_roles: [],
    };
  }

  componentDidMount() {
    listActiveModules();

    createSidebar({
      title: __('topbar.account.company-settings'),
      items: [
        {
          title: __('submenu.title.company-details'),
          link: () => '/company/details',
        },
        {
          title: __('submenu.title.offices'),
          link: () => '/company/offices',
        },
        {
          title: __('company-settings.submenu.title.brands'),
          link: () => '/company/brands',
        },
        {
          title: __('company-settings.submenu.title.disciplines'),
          link: () => '/company/disciplines',
        },
        {
          title: __('submenu.title.market'),
          link: () => '/company/market',
        },
        {
          title: __('submenu.title.company_holidays'),
          link: () => '/company/company_holidays',
        },
        {
          title: __('submenu.title.company_positions'),
          link: () => '/company/company_positions',
          active: true,
        },
        {
          title: __('submenu.title.company_segments'),
          link: () => '/company/company_segments',
        },
        {
          title: __('submenu.title.company_benefits'),
          link: () => '/company/company_benefits',
        },
        {
          title: __('submenu.title.company_folders'),
          link: () => '/company/company_folders',
        },
        {
          title: __('submenu.title.planning_templates'),
          link: () => '/company/planning-templates/stages',
        },
        {
          title: __('submenu.title.tags'),
          link: () => '/company/tags',
        },
        _.includes(
          this.props.auth?.permissions,
          'view.permissions.in.permission.manager'
        )
          ? {
              title: __('submenu.title.company_roles_and_permissions'),
              link: () => '/company/company_roles_and_permissions',
            }
          : null,
      ].filter(Boolean),
      // {
      //     title: __("submenu.title.subscription-and-billing"),
      //     link: () => "/company/subscription"
      // }
    });

    setPlusActions([
      {
        title: __('company_positions.table.button.create'),
        onClick: () =>
          this.props.actions.setTableParams({
            wizard_active: true,
          }),
      },
    ]);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        this.setState({ preview: undefined });
      }

      readCompanyPosition(this.props.table.clicked_row).then(({ response }) => {
        this.setState({ preview: response.data });
      });
    }
  }

  _handleOpacity(value, row) {
    return !row.deactivated ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  @autobind
  _handleSubmit(formData) {
    return validateForm(
      updateCompanyPosition(formData.id, _.omit(formData, ['id'])).then(() => {
        listCompanyPositions();

        readCompanyPosition(getURLParam('id')).then(({ response }) => {
          this.setState({ preview: response.data });
        });

        setNotification(
          __('company-settings.positions.notification.success-saved')
        );
      })
    );
  }

  render() {
    const columns = [
      {
        key: 'name',
        name: __('table.columns.company-position.name'),
        required: true,
        value: (value) => <Tooltip text={value}>{value}</Tooltip>,
      },
      {
        key: 'abbreviation',
        name: __('table.columns.company-position.abbreviation'),
        width: 500,
        required: true,
        value: (value) => <Tooltip text={value}>{value}</Tooltip>,
      },
    ];

    const singleActions = (id) => {
      let actions = [];

      actions.push([
        <Tooltip
          text={__('table.positions.actions.delete.tooltip')}
          key={_.uniqueId()}
        >
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();

              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: __(
                  'table.positions.actions.delete.tooltip.this-process-cannot-undone'
                ),
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-delete'),
                    onClick: () => {
                      deleteCompanyPosition(id).then(() => {
                        hideAlertbox();

                        setNotification(
                          __(
                            'table.positions.actions.delete.selected-company-position-deleted'
                          )
                        );
                        listCompanyPositions();

                        this.props.actions.setTableParams({
                          selected_rows: undefined,
                        });
                      });
                    },
                  },
                ],
              });
            }}
          />
        </Tooltip>,
      ]);

      return actions;
    };

    const preview = (
      <div className={styles.preview}>
        <div className={styles.header}>
          <div className={styles.title}>
            <span>
              <strong>{get(this.state, 'preview.name')}:</strong>{' '}
              {get(this.state, 'preview.abbreviation')}
            </span>
            <CloseBigIcon
              onClick={() =>
                this.props.actions.setTableParams({
                  clicked_row: undefined,
                })
              }
            />
          </div>
        </div>
        <div className={styles.scroller}>
          <div className={styles.form}>
            <EditCompanyPositionsForm
              // isProjectAdministrator={this.state.is_project_administrator}
              onSubmit={this._handleSubmit}
              initialValues={_.pick(get(this.state, 'preview'), [
                'id',
                'name',
                'abbreviation',
              ])}
            />
          </div>
        </div>
      </div>
    );

    return (
      <Table
        listAction={listCompanyPositions}
        name='company_positions'
        title={__('submenu.title.company_positions')}
        columns={columns}
        singleActions={singleActions}
        preview={get(this.state, 'preview') ? preview : []}
        onLoad={() => listActiveModules()}
      />
    );
  }
}

export default CompanyPositions;
